import cn from 'classnames';
import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import styles from './styles.module.css';

const PaginationItem = (props) => {
  const { children, className, active, ...rest } = props;

  const classes = cn(
    `${styles.paginationItem} ${active ? styles.active : ''}`,
    className
  );

  return (
    <Pagination.Item className={classes} {...rest}>
      {children}
    </Pagination.Item>
  );
};

const PaginationFirst = (props) => {
  const { children, className, ...rest } = props;

  const classes = cn(`${styles.paginationItem} `, className);

  return (
    <Pagination.First className={classes} {...rest}>
      {children}
    </Pagination.First>
  );
};

const PaginationPrev = (props) => {
  const { children, className, ...rest } = props;

  const classes = cn(`${styles.paginationItem}`, className);

  return (
    <Pagination.Prev className={classes} {...rest}>
      {children}
    </Pagination.Prev>
  );
};

const PaginationNext = (props) => {
  const { children, className, ...rest } = props;

  const classes = cn(`${styles.paginationItem} `, className);

  return (
    <Pagination.Next className={classes} {...rest}>
      {children}
    </Pagination.Next>
  );
};

const PaginationLast = (props) => {
  const { children, className, ...rest } = props;

  const classes = cn(`${styles.paginationItem} `, className);

  return (
    <Pagination.Last className={classes} {...rest}>
      {children}
    </Pagination.Last>
  );
};

const PaginationEllipsis = (props) => {
  const { children, className, ...rest } = props;

  const classes = cn(`${styles.paginationEllip} `, className);

  return (
    <Pagination.Ellipsis className={classes} {...rest}>
      {children}
    </Pagination.Ellipsis>
  );
};

const PaginationSection = ({ currentPage, totalPages, setCurrentPage }) => {
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPageNumbers = () => {
    const pageItems = [];
    pageItems.push(
      <PaginationItem
        key={1}
        onClick={() => handlePageChange(1)}
        active={currentPage === 1}
      >
        1
      </PaginationItem>
    );

    if ((currentPage === 1 || currentPage === 2) && totalPages > 1) {
      pageItems.push(
        <PaginationItem
          key={2}
          onClick={() => handlePageChange(2)}
          active={currentPage === 2}
        >
          2
        </PaginationItem>
      );
    }

    if (currentPage > 3) {
      pageItems.push(<PaginationEllipsis key="start-ellipsis" />);
    }

    if (currentPage > 2 && currentPage < totalPages) {
      pageItems.push(
        <PaginationItem
          key={currentPage - 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          {currentPage - 1}
        </PaginationItem>
      );
    }

    if (currentPage !== 1 && currentPage !== 2 && currentPage !== totalPages) {
      pageItems.push(
        <PaginationItem key={currentPage} active>
          {currentPage}
        </PaginationItem>
      );
    }

    if (currentPage < totalPages - 1 && currentPage > 1) {
      pageItems.push(
        <PaginationItem
          key={currentPage + 1}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {currentPage + 1}
        </PaginationItem>
      );
    }

    if (currentPage < totalPages - 2) {
      pageItems.push(<PaginationEllipsis key="end-ellipsis" />);
    }

    if (currentPage === totalPages && totalPages > 1) {
      pageItems.push(
        <PaginationItem
          key={totalPages - 1}
          onClick={() => handlePageChange(totalPages - 1)}
        >
          {totalPages - 1}
        </PaginationItem>
      );
    }

    if (totalPages > 1) {
      pageItems.push(
        <PaginationItem
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
          active={currentPage === totalPages}
        >
          {totalPages}
        </PaginationItem>
      );
    }
    return pageItems;
  };

  return (
    <Pagination className="justify-content-end mt-3">
      <PaginationFirst
        onClick={() => handlePageChange(1)}
        disabled={currentPage === 1}
      />
      <PaginationPrev
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
      {renderPageNumbers()}
      <PaginationNext
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
      <PaginationLast
        onClick={() => handlePageChange(totalPages)}
        disabled={currentPage === totalPages}
      />
    </Pagination>
  );
};

export default PaginationSection;
